import './styles.scss';
import { UtrvStatus } from '@constants/status';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { UniversalTrackerValuePlain } from '@g17eco/types/universalTrackerValue';
import { getStatusReadableText, getStatusText } from '@utils/universalTrackerValue';
import { Badge } from 'reactstrap';

interface Props {
  utrv: Pick<UniversalTrackerValuePlain, 'status' | 'value' | 'valueData' | 'assuranceStatus' | 'lastUpdated'>;
  className?: string;
}

export const StatusBadge = ({ utrv, className = '' }: Props) => {
  return (
    <div className={`badge__wrapper ${className}`}>
      <SimpleTooltip text={getStatusText(utrv)}>
        <Badge className={`status-info px-4 py-1 ${utrv.status}`} pill>
          {getStatusReadableText(utrv.status as UtrvStatus)}
        </Badge>
      </SimpleTooltip>
    </div>
  );
};
